import { createContext, useContext, useState } from "react";

const WizardModalContext = createContext({});

export const useWizardModal = () => {
	const context = useContext(WizardModalContext);
	if (context === undefined) {
		throw new Error("useWizardModal must be used within a WizardModalContextProvider");
	}
	return context;
};

export function WizardModalContextProvider({ children, initialSteps }) {
	const [steps, setSteps] = useState(initialSteps);
	const [wizardStep, setWizardStepState] = useState(1);
	const [wizardVisible, setWizardVisible] = useState(1);

	const isFirstStep = wizardStep === 1;

	const setWizardStep = (step) => {
		setWizardStepState(step);
	};

	const goToStep = (index) => {
		if (index > 0) {
			setWizardStep(index);
			setTimeout(() => {
				setWizardVisible(index);
			}, 250);
		}
	};

	const goToNextStep = () => {
		setWizardVisible(0);
		setTimeout(() => {
			setWizardStep((s) => s + 1);
		}, 200);
	};

	const goToPrevStep = () => {
		if (wizardStep !== 1) {
			setWizardVisible(0);
			setTimeout(() => {
				setWizardStep((s) => s - 1);
			}, 200);
		}
	};

	const resetWizard = () => {
		setWizardStep(1);
		setWizardVisible(1);
	};

	const context = {
		steps,
		goToStep,
		goToNextStep,
		goToPrevStep,
		isFirstStep,
		wizardStep,
		wizardVisible,
		setWizardStep,
		setWizardVisible,
		resetWizard,
	};

	return <WizardModalContext.Provider value={context}>{children}</WizardModalContext.Provider>;
}

export default WizardModalContext;
